import React from "react";

const ScreenWidthContext = React.createContext<number>(window.innerWidth);

export {ScreenWidthContext};